export default __webpack_public_path__ + "static/media/professional.687c6b29.webp";